export default {
  SERVER_URL: "https://seeaiapi.pre.hqjy.com/",
};
